import { createFileRoute, useParams } from "@tanstack/react-router";
import { LeadDetailPage } from "@/components/crm/LeadDetailPage";

export const Route = createFileRoute("/admin/_layout/crm/leads_/$id")({
  component: AdminLeadDetail,
});

function AdminLeadDetail() {
  const { id } = useParams({ from: "/admin/_layout/crm/leads_/$id" });
  return <LeadDetailPage leadId={id} role="admin" />;
}
